import $ from 'jquery';
import appAjax from '../helpers/ajax';
import { useEffect, useState } from 'react';
import Loader from '../components/Loader';

export default function ModalActivityLog(props)
{
  var isInitialLoad = false;

  const [elModal, setElModal] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const [page, setPage] = useState(null);
  const [listActivityLog, setListActivityLog] = useState([]);
  const [listMasterActivity, setListMasterActivity] = useState([]);
  const [selectedActivityUuids, setSelectedActivityUuids] = useState([]);

  const doLoadMasterActivity = () => {
    appAjax._ajax_send(null, {
      type: 'GET',
      success: (response) => {
        setListMasterActivity(response.data || []);
      },
      error: (response) => {
        setErrorMessage(response.message || 'Failed to load activity types');
      }
    }, 'Get master data...', appAjax.apiBaseUrl + '/activity/masters');
  };

  const onToggleActivityFilter = (uuid) => {
    setSelectedActivityUuids((prev) => {
      if (prev.includes(uuid)) {
        return prev.filter((id) => id !== uuid);
      }
      return [...prev, uuid];
    });
    setPage(1);
  };

  const onClickPrev = (e) => {
    e.preventDefault();
    if (page > 1) {
      setPage(prevPage => prevPage - 1);
    }
  };

  const onClickLoadMore = (e) => {
    e.preventDefault();
    setPage(prevPage => prevPage + 1);
  };

  useEffect(() => {
    if (page === null) return; // Skip initial load

    var url = appAjax.apiBaseUrl + '/activity/logs?limit=10&page=' + page;
    if (selectedActivityUuids.length > 0) {
      selectedActivityUuids.forEach((uuid) => {
        url += '&activity[]=' + encodeURIComponent(uuid);
      });
    }

    appAjax._ajax_send(null, {
      type: 'GET',
      beforeSend: () => {
        setIsLoading(true);
        setErrorMessage(null);
      },
      success: (response) => {
        setListActivityLog(response.data);
      },
      error: (response) => {
        setErrorMessage(response.message || 'Failed to load activity logs');
      },
      always: () => {
        setIsLoading(false);
      }
    }, 'Fetching data...', url);
  }, [page, selectedActivityUuids]);

  useEffect(() => {
    if (isInitialLoad) return;
    isInitialLoad = true;

    var tmp = $('#web_modal_activitylog');
    setElModal(tmp);

    $(tmp).on('shown.bs.modal', () => {
      setSelectedActivityUuids([]);
      setListMasterActivity([]);
      doLoadMasterActivity();
      setPage(1);
    });
  }, []);

  const filterLabel = selectedActivityUuids.length === 0
    ? 'All types'
    : selectedActivityUuids.length + ' selected';

  return (
    <div
      className="modal"
      style={{ display: "none" }}
      tabIndex={-1}
      id="web_modal_activitylog"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"><i className="fa fa-history me-1"></i> Activity Log</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>    
          <div className="modal-body p-0">
            <div className="p-3 border-bottom">
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-light dropdown-toggle"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fa fa-filter me-1"></i> {filterLabel}
                </button>
                <div className="dropdown-menu p-2" style={{ minWidth: 220, maxHeight: 280, overflowY: 'auto' }}>
                  {listMasterActivity.length === 0 ? (
                    <div className="text-muted small px-2">Loading types...</div>
                  ) : (
                    listMasterActivity.map((item) => (
                      <label
                        key={item.uuid}
                        className="dropdown-item mb-0 d-flex align-items-center"
                        style={{ cursor: 'pointer' }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <input
                          type="checkbox"
                          className="mr-2"
                          style={{ marginRight: 8 }}
                          checked={selectedActivityUuids.includes(item.uuid)}
                          onChange={() => onToggleActivityFilter(item.uuid)}
                        />
                        <i className={'mr-1 ' + item.activity_icon_class}></i>
                        <span>{item.activity_label}</span>
                      </label>
                    ))
                  )}
                </div>
              </div>
            </div>

            {isLoading ? (
              <div className="text-center p-0">
                <Loader />
              </div>
            ) : (
              <div className="p-0">
                {errorMessage ? (
                  <div className="alert alert-danger">{errorMessage}</div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-striped table-sm mb-0" style={{ fontSize: '0.9em' }}>
                      <thead>
                        <tr>
                          <th style={{ width: '32px' }}>&nbsp;</th>
                          <th>Activity</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listActivityLog.map((log, index) => (
                          <tr key={index}>
                            <td>&bull;</td>
                            <td>
                              <div style={{ fontSize: '0.8em'}} className="text-muted">
                                {log.long_created_at}, IP: {log.ip_address}
                              </div>
                              <div className="mb-1 badge badge-secondary">
                                <i className={'me-1 '+log.activity_icon_class}></i> {log.activity_label}
                              </div>
                              <pre style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{log.notes}</pre>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan={2} className="text-center">
                            {page > 1 && (
                              <button className="btn btn-sm btn-outline-secondary me-2" onClick={onClickPrev}
                                style={{ marginRight: 10 }}>
                                <i className="fa fa-chevron-left"></i> Previous
                              </button>
                            )}
                            <span style={{ marginRight: 10 }}>Page {page}</span>
                            {listActivityLog.length >= 10 && (
                              <button className="btn btn-sm btn-outline-secondary" onClick={onClickLoadMore}>
                                Next <i className="fa fa-chevron-right"></i></button>
                            )}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              data-dismiss="modal"
            >
              <i className='fa fa-check-square'></i> OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
